<template>
  <div v-if="showMobileSidebar" class="fixed inset-0 bg-black/50 z-40 xl:hidden" @click="closeMobileSidebar"></div>

  <aside
    ref="sidebarRef"
    :class="[
      'fixed top-0 left-0 h-full bg-white dark:bg-slate-900 z-50 w-80 transform transition-all duration-300 ease-in-out overflow-y-auto xl:hidden',
      showMobileSidebar ? 'translate-x-0' : '-translate-x-full'
    ]"
  >
    <div class="p-4">
      <div class="flex items-center justify-between mb-4">
        <RouterLink :to="{ name: 'payment' }" aria-label="YouPark" class="inline-flex">
          <IconLogo class="h-8" />
        </RouterLink>
        <button
          type="button"
          aria-label="Close navigation menu"
          class="p-2 text-gray-600 dark:text-white hover:text-gray-900 dark:hover:text-slate-200 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg transition-colors"
          @click="closeMobileSidebar"
        >
          <IconX class="w-6 h-6" />
        </button>
      </div>

      <div class="mb-3">
        <LanguageSwitcher />
      </div>

      <div class="mb-3">
        <ThemeToggle layout="sidebar" />
      </div>

      <div class="mb-4">
        <UserProfileCard />
      </div>

      <NavigationMenu />
    </div>
  </aside>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from "vue";

import LanguageSwitcher from "@core/components/shared/LanguageSwitcher.vue";
import NavigationMenu from "@core/components/shared/NavigationMenu.vue";
import UserProfileCard from "@core/components/shared/UserProfileCard.vue";
import { useNavigation } from "@core/composables/state/useNavigation";
import { useRouterContext } from "@core/composables/state/useRouteContext";
import IconLogo from "@core/icons/IconLogo.vue";
import IconX from "@core/icons/IconX.vue";

import ThemeToggle from "../components/ThemeToggle.vue";

const { showMobileSidebar, closeMobileSidebar } = useNavigation();
const sidebarRef = ref<HTMLElement | null>(null);
const router = useRouterContext();
let removeAfterEach: (() => void) | undefined;

watch(showMobileSidebar, (isOpen, wasOpen) => {
  if (!isOpen && wasOpen && sidebarRef.value) {
    sidebarRef.value.scrollTop = 0;
  }
});

onMounted(() => {
  removeAfterEach = router.afterEach(() => {
    closeMobileSidebar();
  });
});

onBeforeUnmount(() => {
  if (removeAfterEach) {
    removeAfterEach();
    removeAfterEach = undefined;
  }
});
</script>
